import ReactDOM from "react-dom";

const EventPortalButton = ({ children }) => ReactDOM.createPortal(
  children,
  document.getElementById("event_footer_right") || document.body
);

export default EventPortalButton;
